import $axios from '@/store/axios-instance.js';

export default {
    state: {
        clientChildList: null,
    },
    mutations: {
        retrieveClientChild(state, payload) {
            state.clientChildList = payload
        },
    },
    actions: {
        retrieveClientChild(context) {
            return new Promise((resolve, reject) => {
                if (!context.getters.currentClient) {
                    context.commit('retrieveClientChild', null)
                    resolve()
                } else {
                    $axios
                        .get(`clients?parentClientId=${context.getters.currentClient.id}`)
                        .then(response => {
                            context.commit('retrieveClientChild', response.data)

                            resolve()
                        })
                        .catch(error => {
                            console.log(error)
                            reject(error)
                        })
                }
            })
        },
    },
    getters: {
        clientChildList(state) {
            return state.clientChildList ?? []
        },
    }
}